import { FC } from 'react';
import { Textarea } from '@mantine/core';
import { Label } from 'components/CreateOrderForm';
import { textareaStyles } from '../constants';
import styles from '../ModalAddingDocument.module.scss';

interface TextFieldProps {
  label: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  error?: string;
}

export const TextField: FC<TextFieldProps> = ({
  label,
  placeholder,
  value,
  onChange,
  required = false,
  error = '',
}) => (
  <div>
    <Label text={label} />
    <Textarea
      placeholder={placeholder}
      required={required}
      autosize
      minRows={1}
      maxRows={4}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      styles={{
        input: {
          ...textareaStyles.input,
          border: error ? '1px solid red' : 'none',
        },
      }}
    />
    {error && <div className={styles.error}>{error}</div>}
  </div>
);
